import { render } from "./HighchartBarChart.vue?vue&type=template&id=235b0e7d&ts=true"
import script from "./HighchartBarChart.vue?vue&type=script&lang=ts"
export * from "./HighchartBarChart.vue?vue&type=script&lang=ts"

import "./HighchartBarChart.vue?vue&type=style&index=0&id=235b0e7d&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__